import React, { useState, useEffect, useContext } from 'react'
import ReceivablesHeader from './ReceivablesHeader'
import ReceivablesInner from './ReceivablesInner'
import ReceivablesFooter from'./ReceivablesFooter'
import { appContext } from '../../../../../../App'
import { getReceivables } from '../../../../ReportsFunctions'

export const receivablesControllerContext = React.createContext()

function useReceivablesController(props) {
  const app = useContext(appContext)
  const [receivables, setReceivables] = useState(null)

  useEffect(() => {
    const init = async () => { setReceivables( await getReceivables(app) ) }
    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    getClientDateTime: app.getClientDateTime,
    getClientTimezone: app.getClientTimezone,
    receivables: [receivables, setReceivables]
  })
}

function ReceivablesController(props) {
  const receivablesController = useReceivablesController(props)
  return (
    <React.Fragment>
      <receivablesControllerContext.Provider value={receivablesController}>
        <ReceivablesHeader />
        <ReceivablesInner />
        <ReceivablesFooter />
      </receivablesControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ReceivablesController)